import { render, staticRenderFns } from "./RuleCreate.vue?vue&type=template&id=539723aa&scoped=true&"
import script from "./RuleCreate.vue?vue&type=script&lang=js&"
export * from "./RuleCreate.vue?vue&type=script&lang=js&"
import style0 from "./RuleCreate.vue?vue&type=style&index=0&id=539723aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539723aa",
  null
  
)

export default component.exports